import styled from "styled-components";

const Title = styled.h1`
  font-weight: 800;
  margin-bottom: 0;
  margin-top: 1rem;
  font-size: 1.8rem;
  color: ${props => props.theme.colors.black};
`
export default Title;
